
export const ZENDESK_SNIPPET_SRC =
  'https://static.zdassets.com/ekr/snippet.js?key=e548dd3d-0ed3-4817-8eba-688d827349ea'

const invokeZendeskMessenger = (
  command: 'show' | 'hide' | 'close'
): void => {
  if (typeof window === 'undefined' || typeof window.zE !== 'function') return
  window.zE('messenger', command)
}

/** Show launcher / bubble on Altair TOP only */
export const showZendeskMessenger = (): void => {
  invokeZendeskMessenger('show')
}

/** Close panel and hide launcher when leaving TOP (SPA keeps widget in DOM) */
export const hideZendeskMessenger = (): void => {
  invokeZendeskMessenger('close')
  invokeZendeskMessenger('hide')
}
